module.exports = __webpack_public_path__ + "static/media/status-complete.3d1da28b.svg";